module.exports = __webpack_public_path__ + "static/media/raiders-silhouette.0bf64675.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/raiders-silhouette.svg
// module id = 1332
// module chunks = 0